import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { useSearchParams } from 'react-router-dom';
import { Facebook } from 'lucide-react';
import { toast } from 'sonner';

interface FacebookLoginProps {
  onSuccess?: () => void;
}

export function FacebookLogin({ onSuccess }: FacebookLoginProps = {}) {
  const { signInWithFacebook } = useAuth();
  const [searchParams] = useSearchParams();

  const handleFacebookLogin = async () => {
    try {
      // Prefer explicit redirect query param; otherwise use current location so users return to the same page
      const redirectTo = searchParams.get('redirect') || `${window.location.pathname}${window.location.search}`;
      await signInWithFacebook(redirectTo);
      // Call onSuccess if provided (for modal closing, etc.)
      onSuccess?.();
    } catch (error) {
      console.error('Facebook sign-in error:', error);
      toast.error('Failed to sign in with Facebook. Please try again.');
    }
  };

  return (
    <Button
      variant="outline"
      type="button"
      className="w-full h-12 text-base font-semibold"
      size="lg"
      onClick={handleFacebookLogin}
    >
      <Facebook className="mr-3 h-5 w-5" />
      Facebook
    </Button>
  );
}